"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagExistsError = void 0;
const client_library_1 = require("@seneca/client-library");
/**
 * Error when tag with same text already exists within parent category
 */
class TagExistsError extends client_library_1.ExtendableError {
    constructor() {
        super(`Tag already exists with that text`);
    }
}
exports.TagExistsError = TagExistsError;
//# sourceMappingURL=TagExistsError.js.map